import React from "react";
import { useTranslation } from "react-i18next";
import { WifiOff, RefreshCw } from "lucide-react";
import styles from "./ServerDownPage.module.css";

interface ServerDownPageProps {
  logo: string;
  onRetry: () => void;
}

export const ServerDownPage: React.FC<ServerDownPageProps> = ({
  logo,
  onRetry,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      <img src={logo} alt="" className={styles.bgLogo} aria-hidden="true" />
      <div className={styles.card}>
        <div className={styles.iconWrap}>
          <WifiOff size={32} className={styles.icon} />
        </div>
        <hr className={styles.divider} />
        <h2 className={styles.title}>{t("error.server.title")}</h2>
        <p className={styles.message}>{t("error.server.message")}</p>
        <button className={styles.retryBtn} onClick={onRetry}>
          <RefreshCw size={15} />
          {t("common.retry")}
        </button>
      </div>
    </div>
  );
};
